import React from 'react'
import { ThemeProvider } from 'styled-components'

function TP({ children, ...props }) {
  return <ThemeProvider theme={{ ...props }}>{children}</ThemeProvider>
}

export default TP
